<div class="header-placeholder">
  <span>{{'measure.platform' | translate}}</span>
</div>
<div class="message-popup">
  <div class="title">{{fallbackTitle}}</div>
  <div class="sub-title">{{fallbackMessage}}</div>
</div>
<div class="d-flex flex-row flex-auto">
  <div class="platform-reach-container" *ngFor="let item of chartItems">
    <!-- REVIEW: What's the best way to set this programmatically? -->
    <achoo-gauge-chart-placeholder [title]="item.name"></achoo-gauge-chart-placeholder>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reach-placeholder/platform-reach-placeholder.component.html